<template>
    <div class="sidebar px-xl-4 px-3 py-2 py-md-3 document dark" id="sidebar">
        <!-- sidebar: title-->
        <div class="title-text d-flex align-items-center mb-4 mt-1">
            <h4 class="sidebar-title mb-0 flex-grow-1"><span class="sm-txt">L</span><span>UNO</span></h4>
        </div>
        <div class="main-menu flex-grow-1">
            <ul class="menu-list">
                <template v-for="(item) in sidebarMenuItems" :key="item">
                    <li class="divider py-2 lh-sm">
                        <span class="text-primary small fw-bold text-uppercase">{{item.title}}</span>
                        <span v-if="item.subtitle">
                            <br><small class="text-muted">{{item.subtitle}}</small>
                        </span>
                    </li>
                    <li v-for="(subItem) in item.menu" :key="subItem">
                        <router-link class="m-link" v-bind:class="{ active: currentRoutePath == subItem }" :to="{ name: subItem}"><i class="fa fa-angle-right"></i>
                            {{subItem}}
                            <span class="badge bg-primary ms-auto" v-if="subItem =='Changelog'">v1.0.0</span>
                        </router-link>
                    </li> 
                </template>
            </ul>
        </div>
    </div>
</template>
<script>
  export default {
    name: 'SidebarDocumentation',
    components: {
    },
    data () {
        return{
            sidebarMenuItems:null,
            domain:null,
            picked: {
                date:new Date(),
                time:''
            }
        }
    },
    methods:{
        async reloadSidebar(){
            this.sidebarMenuItems = [
                {
                    title:"Documentation",
                    subtitle:null,
                    menu : [ "Overview","Dev Setup","File Structure","References","Helper Class","Stater Page","Animation","Changelog"]
                },
                {
                    title:"Widget Card's",
                    subtitle:'Handcrafted Cards',
                    menu : [ "Basic Card","Card Tiles","User's Card","Tabbed Card","Card Ribbons","Card List","Widget Chart","Card Table"]
                },
                {
                    title:"Charts",
                    subtitle:null,
                    menu : [ "Apex Chart","ChartJS" ,"Round Slider","Sparkline"]
                },
                {
                    title:"Advanced Elements",
                    subtitle:null,
                    menu:["Clipboard","Colorpicker","Datepicker","Dropify","Flatpickr","Image Input","Inputmask",'Slider',"Password Meter","Sweetalert2","Tagsinput","Select2","Draggable"]//"nouislider","Rangeslider","Multiselect Splitter"
                },
                {
                    title:"Form Elements",
                    subtitle:null,
                    menu : [ "Bootstrap Form","Form Wizard horizontal","Custom Form"]//Form Wizard Vertical,Form Wizard Validate
                },
                {
                    title:"Font Icons",
                    subtitle:null,
                    menu : [ "Font Awesome","Simple line","Weather Icons","Icons8 Line Awesome","Bootstrap Icon","Flag Icon","SVG Custom Icon"]//Feather Icons
                },
                {
                    title:"Plugins",
                    subtitle:'Manage with npm install',//"jsGrid Table","Masonry Gallery","FancyBox Gallery","Drag & Drop","jquery Nestable","jQuery skedTape",,"Table Dragger","Tagify","X-editable","Swiper","JSpreadSheet","jQuery Bar Rating","Bootstrap stepper","Bootstrap 5 Toast"
                    menu : ["DataTables","Editor","Carousel","Typed.js",'Fullcalendar',"Cropper","Bootstrap submenu"]
                },
                {
                    title:"Components",
                    subtitle:'Bootstrap 5 Components',
                    menu : [ "Alerts","Avatar","Badge","Borders","Breadcrumb","Buttons","Card","Bootstrap Carousel","Collapse","Dropdowns","List group","Modal","Navbar","Navs","Pagination","Progress","Scrollspy","Spinners","Toasts","Thank You!"]
                }
            ];
            
        },
        hideSidebar(){
            document.getElementById('sidebar').classList.remove('open');
        }
    },
    async mounted(){
        await this.reloadSidebar();
    },
    async created(){
        await this.reloadSidebar();
    },
    computed: {
        currentRoutePath() {
            return this.$route.name;
        },
        currentTab() {
            return this.$route?.matched[0]?.name;
        },
    },
    watch: {
        $route() {
           this.reloadSidebar();
           this.hideSidebar();
        },
    },
  }
</script>

<style>
  .layout-1 .document.sidebar {
    width: 260px;
  }

  .layout-1 .document.sidebar .title-text {
    flex-direction: row;
  }

  .layout-1 .document.sidebar .menu-list {
    border: 0;
    padding: 0;
  }

  .layout-1 .document.sidebar .menu-list li {
    border: 0;
  }

  .layout-1 .document.sidebar .menu-list .m-link {
    padding: 4px 0;
  }

  .layout-1 .document.sidebar .menu-list .m-link>i {
    text-align: left;
    margin: 0;
    width: 20px;
  }
</style>
  